import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {selectLocale} from '../reducers/locales';
import {closeLanguageMenu} from '../reducers/menus';
import ScratchBlocks from 'scratch-blocks';

import {
    tabsActive
} from '../reducers/editor-tab';

import LanguageSelectorComponent from '../components/language-selector/language-selector.jsx';

class LanguageSelector extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange',
            'forNew',
            'switchShowStage'
        ]);
        document.documentElement.lang = props.currentLocale;
    }
    componentDidMount(){
        this.switchShowStage()
    }
    handleChange (e) {
        var p = new Promise((resolve,reject) => {
            const newLocale = e.target.getAttribute('data-value');
            if (this.props.messagesByLocale[newLocale]) {
                this.props.onChangeLanguage(newLocale);
                document.documentElement.lang = newLocale;
            }
            resolve()
        })
        
        p.then(()=>{
            const newediting = this.props.vm.editingTarget
        
            if(newediting.robotType == 'role'){
                this.forNew(1)
            }else if(newediting.robotType == 'bg'){
                this.forNew(2)
            }else{
                this.forNew(0)  
            }
            ScratchBlocks.BlocksonChange();// 切换语言，让模块超出的部分可以显示出来

            if(document.getElementsByClassName("CodeMirror")[0] && window.getComputedStyle(document.getElementsByClassName("CodeMirror")[0]).display == "block"){
                this.props.clickToEditpanel()
            }else{
                this.props.clickToBlockpanel()
            }

        })

    }
    forNew(a){
        this.props.onTabsActive(a)
    }
    switchShowStage(){
            const newediting = this.props.vm.editingTarget || 'E6'
        
            if(newediting.robotType == 'role'){
                this.props.setStateTrue('showStage')
            }else if(newediting.robotType == 'bg'){
                this.props.setStateTrue('showStage')
            }else{
                this.props.setStateFalse('showStage')  
            }
    }
    render () {
        const {
            onChangeLanguage, // eslint-disable-line no-unused-vars
            messagesByLocale, // eslint-disable-line no-unused-vars
            children,
            ...props
        } = this.props;
        return (
            <LanguageSelectorComponent
                onChange={this.handleChange}
                languageMenuOpen = {this.props.languageMenuOpen}
                {...props}
            >
                {children}
            </LanguageSelectorComponent>
        );
    }
}

LanguageSelector.propTypes = {
    children: PropTypes.node,
    currentLocale: PropTypes.string.isRequired,
    // Only checking key presence for messagesByLocale, no need to be more specific than object
    messagesByLocale: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    onChangeLanguage: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentLocale: state.locales.locale,
    messagesByLocale: state.locales.messagesByLocale
});

const mapDispatchToProps = dispatch => ({
    onChangeLanguage: locale => {
        dispatch(selectLocale(locale));
        dispatch(closeLanguageMenu());
    },
    onTabsActive: (a) => {
        dispatch(tabsActive(a))
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LanguageSelector);
